import { createContext, useState, useRef } from 'react'
const GlobalStorage = createContext()
export default GlobalStorage;


export const DataStorage = ({ children }) => {
    const [scroll, setScroll] = useState(useRef(null))
    const [which, setWhich] = useState('')
    const [showModel, setShowModel] = useState(false)
    const schoolResults = useRef(null)

    return (
        <GlobalStorage.Provider value={{
            scroll, setScroll,
            schoolResults,
            showModel, setShowModel,
            which, setWhich
        }} >
            {children}
        </GlobalStorage.Provider>
    )
}
